import React from 'react';
import '../styles/HeroSection.css';
import heroImage from '../assets/images1.jpg';

const HeroSection = () => {
  return (
    <section className="hero-section" id="accueil">
      <div className="hero-content">
        <div className="hero-text">
          <h1>Recommandez <span>ISPATEC</span>,<br />et gagnez des <span>primes</span> !</h1>
          <p>Devenez influenceur partenaire et participez à la réussite de futurs étudiants tout en étant récompensé.</p>
          <a href="#how" className="hero-btn">Comment ça marche</a>
        </div>
        <div className="hero-image">
          <img src={heroImage} alt="Affiliation illustration" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
